import axios, { AxiosResponse } from 'axios';

import { ETypZadostiLei } from 'enums/lei/leiDataEnums';
import { ELeiGleifStav } from 'enums/lei/leiGleifStav';

export interface ILeiItem {
    oid: number;
    lei: string;
    legalname: string;
    registauthorityentityid: string;
    entitystatus: 'ACTIVE' | 'INACTIVE';
    registrationstatus: ELeiGleifStav;
    lastupdatedate: string;
}

export interface ILeiPrehled {
    offset: number;
    limit: number;
    count: number;
    order: string;
    seznamlei: ILeiItem[];
}

export interface ILeiDetail {
    entity: {
        oid?: number;
        lei: string;
        legalname: string;
        translitotherentityname: string;
        headquartersaddress: {
            firstaddressline: string;
            city: string;
            country: string;
            postalCode: string;
        };
        registrationauthorityid: string;
        otherregistauthorityid?: string;
        registauthorityentityid: string;
        legaljurisdiction: string;
        entitycategory: ETypZadostiLei[];
        entitylegalformcode: string;
        otherlegalform?: string;
        entitystatus: string;
        entitycreationdate: string;
    };
    registration: {
        initialregistrationdate: string;
        lastupdatedate: string;
        registrationstatus: ELeiGleifStav;
        nextrenewaldate: string;
        managinglou: string;
    };
    releationship: {
        startnodeid: string;
        endnodeid: string;
        relationshiptype: string;
        relationshipstatus: string;
        registrationstatus: string;
    }[];
    exceptions: {
        lei: string;
        exceptioncategory: string;
        exceptionreason: string;
    }[];
    datelastloaded: string;
}

export interface ILeiPrehledInput {
    offset: number;
    limit: number;
    order: string;
    lei?: string;
    regauthentityid?: string;
    legalname?: string;
}

const leiUctyApi = (params: ILeiPrehledInput) => {
    return axios({
        method: 'GET',
        url: `https://${window.location.hostname}/isbpublicjson/api/LegalEntity`,
        params: params
    }).then((resp: AxiosResponse<ILeiPrehled>) => resp.data);
};

export const leiDetailApi = (id: string | number) => {
    return axios({
        method: 'GET',
        url: `https://${window.location.hostname}/isbpublicjson/api/LegalEntity/${id}`
    }).then((resp: AxiosResponse<ILeiDetail>) => resp.data);
};

export default leiUctyApi;
